import { render, staticRenderFns } from "./ProjectsHome.vue?vue&type=template&id=ab70246a"
import script from "./ProjectsHome.vue?vue&type=script&lang=js"
export * from "./ProjectsHome.vue?vue&type=script&lang=js"
import style0 from "./ProjectsHome.vue?vue&type=style&index=0&id=ab70246a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab70246a')) {
      api.createRecord('ab70246a', component.options)
    } else {
      api.reload('ab70246a', component.options)
    }
    module.hot.accept("./ProjectsHome.vue?vue&type=template&id=ab70246a", function () {
      api.rerender('ab70246a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/pages/ProjectsHome.vue"
export default component.exports